import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { ButtonSize } from '@wix/da-ds/pkg/Buttons/types';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import CheckIcon from '@wix/da-ds/pkg/Icons/24x24/Check';
import CheckIcon16 from '@wix/da-ds/pkg/Icons/16x16/Check';
import useIconSizeForButtonSize from '@wix/da-ds/pkg/Buttons/hooks/useIconSizeForButtonSize';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { URLS } from '@wix/da-url';
import { DeviationResourceType } from '../../../types/deviation';
import { BiData, TierSubscribeBiEvent } from '@wix/da-bi/pkg/events';

import s from './Subscribed.scss';

export interface Props {
  tier: PapiDeviation;
  className?: string;
  href?: string;
  size?: ButtonSize;
}

const SubscribedVariant: React.FC<Props> = ({ tier, className, size = 'medium', href }) => {
  const { t } = useTranslation();
  const iconSize = useIconSizeForButtonSize(size);
  const icon = iconSize === IconSize.SMALLER ? CheckIcon16 : CheckIcon;

  return (
    <SolidButton
      className={c(s['root'], className)}
      size={size}
      variant="main"
      icon={icon}
      priority="secondary"
      href={href}
      isFakeButton={!href}
      biData={BiData<TierSubscribeBiEvent>({
        evid: 550,
        typeid: DeviationResourceType.TIER,
        itemid: tier.deviationId,
        referral_info:
          (typeof window !== 'undefined' && window.location.href === URLS.ORDERS
            ? ReferralType.BILLING_PAYMENTS
            : ReferralType.TIER_CARD) || ReferralType.TIER_CARD,
      })}
    >
      {t('deviation.tier.subscribed')}
    </SolidButton>
  );
};
SubscribedVariant.displayName = 'SubscribedVariant';

export default SubscribedVariant;
